import { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { find } from 'lodash';
import { useTranslation } from 'react-i18next';

import { AlertOutlineIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import useGetTotalRequestReschedule from 'Domain/reschedule/useGetTotalRequestReschedule';
import InputTab from 'UiKit/input-tab';
import { TextBold, TextRegular } from 'UiKit/typography';

import { SkeletonApprovalType } from 'View/reschedule-form/component/skeleton';
import getAlertRescheduleLabel from 'View/reschedule-form/helper/getAlertRescheduleLabel';

import styles from './styles.module.css';

const SWAP_SCHEDULE_VALUE = 1;

const ApprovalType = ({ form, approvalTypeOptions, isFetchingList, isChangeScheduleAvailable }) => {
  const { t } = useTranslation('host-reschedule');
  const { setValue, watch } = form;

  const { data: dataTotalRequest, isFetching: isFetchingTotal } = useGetTotalRequestReschedule();

  const { approvalType } = watch();

  const isQuotaExist = dataTotalRequest?.remaining > 0;
  const isLoading = !isFetchingList || !isFetchingTotal;

  const translatedOptions = approvalTypeOptions?.map((option) => ({
    ...option,
    label: option.value === SWAP_SCHEDULE_VALUE ? t('request_type.swap_schedule') : t('request_type.change_host'),
  }));

  const alertChangeScheduleLabel = getAlertRescheduleLabel(dataTotalRequest, approvalTypeOptions);
  const alertChangeScheduleText = t(alertChangeScheduleLabel.key, alertChangeScheduleLabel.options);
  const isScheduleAvailableNeutralAlert = dataTotalRequest?.remaining > 1 || isChangeScheduleAvailable;

  useEffect(() => {
    if (approvalTypeOptions && (!isChangeScheduleAvailable || !isQuotaExist)) {
      const changeHostOption = find(translatedOptions, { value: 2 });
      setValue('approvalType', changeHostOption);
    }
    // eslint-disable-next-line
  }, [isQuotaExist, approvalTypeOptions, setValue, isChangeScheduleAvailable]);

  return (
    <Box className={styles['approval-type__container']}>
      <Condition statement={isLoading} fallback={<SkeletonApprovalType />}>
        <TextBold className={styles['approval-type__title-step-text']}>
          {t('select_request_type')} <span>*</span>
        </TextBold>

        <InputTab
          options={translatedOptions}
          selectedTab={approvalType}
          handleChange={(value) => {
            setValue('approvalType', value);
          }}
        />

        <Condition statement={approvalType?.value === SWAP_SCHEDULE_VALUE}>
          <Box className={styles['approval-type__max-chance--container']}>
            <AlertOutlineIcon color={isScheduleAvailableNeutralAlert ? 'var(--color-neutral70)' : 'var(--color-error50)'} size={11} />
            <TextRegular
              className={`
                ${styles['approval-type__max-chance--text']}
                ${isScheduleAvailableNeutralAlert ? '' : styles['approval-type__no-request-text']}`}
            >
              {alertChangeScheduleText}
            </TextRegular>
          </Box>
        </Condition>
      </Condition>
    </Box>
  );
};

export default ApprovalType;
